import api from "@/api";
import axios from "axios";

export default {
  // 배너웹파트 이미지파일 업로드
  uploadFile(formData: FormData) {
    return axios.post("/cm/file/store/api/flow", formData, {
      headers: { "Content-Type": "multipart/form-data", withCredentials: true },
    });
  },

  // 배너웹파트 업로드 이미지파일 삭제
  deleteByCode(code: string): Promise<any[]> {
    return api.get({
        url: `/file/store/api/ClearFile`,
        params: {
            code: code
        }
    });
  },

  // 배너웹파트 생성
  addNewBanner(data: webpartBanner.Banner): Promise<number> {
    return api.post({
      url: `/Webpart/WebpartBanner/api/create`,
      data: data,
    });
  },

  // 배너웹파트 배너 목록 가져오기(설정화면)
  getBannerList(
    comcode: string,
    isGlobal: boolean,
    mappingId: string
  ): Promise<webpartBanner.Banner[]> {
    return api.get({
      url: `/Webpart/WebpartBanner/api/adminList?comcode=${comcode}&isGlobal=${isGlobal}&mappingId=${mappingId}`,
    });
  },

  // 배너웹파트 정렬 변경
  updateBannerOrder(bannerId: number, num: number): Promise<number> {
    return api.post({
      url: `/Webpart/WebpartBanner/api/order?banner=${bannerId}&val=${num}`,
    });
  },

  // 배너 삭제
  deleteBannerItem(bannerId: number): Promise<number> {
    return api.put({
      url: `/Webpart/WebpartBanner/api/edit?bannerId=${bannerId}`,
    });
  },

  // 배너 정렬 설정 저장
  updateBannerList(
    bannerIds: string,
    isGlobal: boolean,
    mappingId: string
  ): Promise<number> {
    return api.put({
      url: `/Webpart/WebpartBanner/api/update?banners=${bannerIds}&isGlobal=${isGlobal}&mappingId=${mappingId}`,
    });
  },
};
